export function buildCreateContext(getContextManager) {
    return function createContext(options) {
        function getContext() {
            const contextManager = getContextManager();
            const value = contextManager.get(options.name);
            if (value) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
                return value;
            }
            if (options.getInitialValue) {
                contextManager.set(options.name, options.getInitialValue());
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
                return contextManager.get(options.name);
            }
            throw new Error(`Context "${options.name}" is not initialized with setContext or getInitialValue.`);
        }
        function setContext(value) {
            getContextManager().set(options.name, value);
        }
        function isContextInitialized() {
            const contextManager = getContextManager();
            return contextManager.has(options.name) || Boolean(options.getInitialValue);
        }
        function resetContext() {
            const contextManager = getContextManager();
            if (options.getInitialValue) {
                contextManager.set(options.name, options.getInitialValue());
            }
            else {
                contextManager.delete(options.name);
            }
        }
        return { getContext, setContext, isContextInitialized, resetContext };
    };
}
